import logo from '../assets/appLogo/Logo.png'

// const configData = {
//   logo,
//   APP_NAME: 'GroNext',
//   country: 'na',
//   continent: 'na',
//   authorization: null,
//   countryCode: '+91-',
//   contactNumberLength: 10,
// }
const configData = {
  logo,
  APP_NAME: 'GRONEXT',
  continent: 'as',
  country: 'in',
  authorization: null,
  countryCode: '+91-',
  contactNumberLength: 10,
}
export default configData
